import React from 'react';
import {
  MainContainer,
  InnerContainer,
  BodyContainer,
  Header,
  Description,
  CopyRights
} from './styled';

const RightContainer = () => {
  return (
    <MainContainer>
      <InnerContainer>
        <BodyContainer>
          <Header>
            FinCense <p>(FinCrime Sensing)</p>
          </Header>
          <Description>
            Tookitaki combines machine learning, distributed systems, and
            business expertise to create the building blocks of sustainable
            compliance management
          </Description>
          <CopyRights>©2021 Tookitaki Holding Pte. Ltd.</CopyRights>
        </BodyContainer>
      </InnerContainer>
    </MainContainer>
  );
};

export default RightContainer;
